<template>
	<div>
		<new-page-gen :options="options" />
	</div>
</template>

<script>
import NewPageGen from './NewPageGen.vue'

const config = {
	options: {
		resource: 'user-tag-keys'
	}
}

export default {
	name: 'UserTagKeysNew',
	components: { NewPageGen },
	data: () => config
}
</script>
